import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { MdFilterListOff } from 'react-icons/md';
import { Stack, Typography } from '@mui/material';

import { styles } from './index.styles';

const NoResultsToShowAdjustFiltersWarning: FC = () => {
  const { t } = useTranslation('followUp');

  return (
    <Stack
      sx={{
        height: '100%',
        justifyContent: 'center',
        alignItems: 'flex-start',
        px: 3,
      }}
    >
      <Stack direction="row" sx={styles.noResultsToShowAdjustFilters}>
        <MdFilterListOff size={20} />
        <Typography variant="caption">
          {t('noResultsToShowAdjustFilters')}
        </Typography>
      </Stack>
    </Stack>
  );
};

export default NoResultsToShowAdjustFiltersWarning;
